'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtConflictsMap', [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			scope: {
				pmtConflictsMap: '@',
				markers: '@',
				dragendCallback: '&',
				markerCallback: '&',
				noClustering: '<',
				popupUseThisButton: '<'
			},
			link: function (scope, element, attrs) {
				// remember that if you load a map that is under ng-show it will be having timing issues. use ng-if instead.
				let map,
					extraMarkers = [],
					allMarkers = [],
					markers = L.markerClusterGroup({ spiderfyDistanceMultiplier: 3, maxClusterRadius: 1 }),
					MAX_ZINDEX = 1000;

				let iconUrl = {
					pinmeto: 'img/map-icons/Blue_MasterData.svg',
					facebook: 'img/map-icons/Gray_Facebook.svg',
					google: 'img/map-icons/Gray_Google.svg',
					bing: 'img/map-icons/Gray_Bing.svg',
					trustpilot: 'img/map-icons/Gray_Trustpilot.svg'
				};
				let iconMiniUrl = {
					pinmeto: 'img/map-icons/Black_MasterData.svg',
					facebook: 'img/map-icons/Gray_Facebook.svg',
					google: 'img/map-icons/Gray_Google.svg',
					bing: 'img/map-icons/Gray_Bing.svg',
					trustpilot: 'img/map-icons/Gray_Trustpilot.svg'
				};

				let iconBlueCheck = L.icon({
					iconUrl: 'img/map-icons/Blue_Check.svg',
					iconSize: [44, 68],
					iconAnchor: [22, 67],
					popupAnchor: [0, 70]
				});

				let iconProgress = L.icon({
					iconUrl: 'img/map-icons/Blue_In_Progress.svg',
					iconSize: [44, 68],
					iconAnchor: [22, 67],
					popupAnchor: [0, 70]
				});

				let iconGreenCheck = L.icon({
					iconUrl: 'img/map-icons/Green_Check.svg',
					iconSize: [44, 68],
					iconAnchor: [22, 67],
					popupAnchor: [0, 70]
				});

				let icons = {};

				let setMarker = function (markerConf) {
						let marker;
						let markerZIndexOffset = MAX_ZINDEX - (markerConf.prio ? markerConf.prio : MAX_ZINDEX);
						let miniMode = element[0].offsetWidth < 150;
						let iconOptions = {};
						if (miniMode) {
							iconOptions.iconUrl = iconMiniUrl[markerConf.iconType];
							iconOptions.iconSize = [32, 46];
							iconOptions.iconAnchor = [13, 42];
							iconOptions.popupAnchor = [0, 44];
						} else {
							iconOptions.iconUrl = iconUrl[markerConf.iconType];
							iconOptions.iconSize = [44, 68];
							iconOptions.iconAnchor = [22, 67];
							iconOptions.popupAnchor = [0, 70];
						}
						let icon = L.icon(iconOptions);
						icons[markerConf.iconType] = icon;

						const hasSomeNetwork =
							['pinmeto', 'facebook', 'google', 'bing', 'trustpilot', 'checkGreen'].indexOf(
								markerConf.iconType
							) > -1;
						if (hasSomeNetwork) {
							markerConf.location = markerConf.location || {};
							markerConf.location.lat = markerConf.location.lat || 0;
							markerConf.location.lon = markerConf.location.lon || 0;
							if (markerConf.iconType === 'pinmeto') {
								marker = L.marker([markerConf.location.lat, markerConf.location.lon], {
									icon: icon
								}).addTo(map);
							} else if (markerConf.isResolved) {
								marker = L.marker([markerConf.location.lat, markerConf.location.lon], {
									icon: iconGreenCheck
								}).addTo(map);
							} else {
								marker = L.marker([markerConf.location.lat, markerConf.location.lon], {
									icon: icon
								});
								if (scope.noClustering) {
									marker.addTo(map);
								} else {
									markers.addLayer(marker);
								}
							}

							// marker.on('click', L.DomEvent.stopPropagation);

							if (scope.popupUseThisButton) {
								let useThisButton = angular.element(
									'<button type="button" class="pmt-btn pmt-btn--default"><span class="pmt-btn__label">Use this</span></button>'
								);
								useThisButton.on('click', function () {
									marker.setIcon(iconProgress);
									marker._pmtMapMarkerState = 'inProgress';
									marker.closePopup();
									scope.markerCallback({ type: 'usethis', data: markerConf.iconType });
								});
								marker.bindPopup(useThisButton[0]);

								marker.on('popupopen', function (e) {
									marker = e.target;
									marker.setIcon(iconBlueCheck);
									marker.setZIndexOffset(MAX_ZINDEX);
									scope.markerCallback({ type: 'popupopen', data: markerConf.iconType });
								});

								marker.on('popupclose', function (e) {
									marker = e.target;
									if (marker._pmtMapMarkerState !== 'inProgress') {
										marker.setIcon(icons[markerConf.iconType]);
										marker.setZIndexOffset(markerZIndexOffset);
									}
									scope.markerCallback({ type: 'popupclose', data: markerConf.iconType });
								});
							}
						} else {
							marker = L.marker([markerConf.location.lat, markerConf.location.lon]); //.addTo(map);
						}

						if (markerConf.prio) {
							marker.setZIndexOffset(markerZIndexOffset);
						}
						if (markerConf.draggable) {
							marker.dragging.enable();
							marker.on('dragend', function (e) {
								marker = e.target;
								let position = marker.getLatLng();
								let coords = {};
								coords.lon = position.lng;
								coords.lat = position.lat;
								if (scope.popupUseThisButton) {
									$timeout(function () {
										marker.openPopup();
									});
								}
								scope.dragendCallback({ location: coords });
							});
						}

						allMarkers.push(marker);

						return marker;
					},
					addMarkers = function (markerObj, maxZoom) {
						let centerMarker = setMarker(markerObj);

						if (extraMarkers.length > 0) {
							let bounds = new L.LatLngBounds();
							bounds.extend(centerMarker.getLatLng());
							extraMarkers.forEach(function (marker) {
								let m = setMarker(marker);
								bounds.extend(m.getLatLng());
							});
							let fitBoundOptions = {
								paddingTopLeft: L.point(0, 0),
								paddingBottomRight: L.point(0, 0),
								padding: L.point(0, 0),
								maxZoom: maxZoom || 15
							};
							map.fitBounds(bounds, fitBoundOptions);
						}
					},
					invalidateSize = function () {
						if (map) {
							map.invalidateSize();
						}
					},
					initMap = function (markerObj) {
						if (!map) {
							angular.element(document).ready(function () {
								let mapElement = element[0],
									mapLocation = markerObj.location,
									mapWidth = element[0].offsetWidth,
									miniMode = mapWidth < 150,
									zoom = miniMode ? 14 : 15;

								if (markerObj.isResolved) {
									zoom = 15;
									miniMode = true;
								}
								map = L.map(mapElement, {
									center: [mapLocation.lat, mapLocation.lon],
									zoom: zoom,
									zoomControl: false,
									attributionControl: !miniMode,
									doubleClickZoom: !miniMode,
									scrollWheelZoom: false,
									dragging: !miniMode,
									disableClusteringAtZoom: 2
								});

								if (!miniMode) {
									new L.Control.Zoom({ position: 'bottomright' }).addTo(map);
								}

								L.tileLayer(
									'https://api.mapbox.com/styles/v1/pinmeto/cjciu9mq68i172so6paoyiuhe/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGlubWV0byIsImEiOiJvZC1QTVpnIn0.AhgCfYhZzLpmcqZYCRoZDA',
									{
										maxZoom: 20,
										minZoom: 4
									}
								).addTo(map);
								addMarkers(markerObj, zoom);
							});
						} else {
							allMarkers.forEach(function (marker) {
								// remove old markers
								map.removeLayer(marker);
								markers.removeLayer(marker);
							});

							addMarkers(markerObj);

							if (extraMarkers.length > 0) {
								map.addLayer(markers);
							}
							invalidateSize();
							setTimeout(function () {
								let group = new L.featureGroup(allMarkers);

								let fitBoundOptions = {
									paddingTopLeft: L.point(44, 68),
									paddingBottomRight: L.point(0, 0)
									// maxZoom: 15
								};
								map && map.fitBounds && map.fitBounds(group.getBounds(), fitBoundOptions);
								invalidateSize();
							}, 600);
						}
					};

				scope.$watch(
					function () {
						return element[0].offsetParent;
					},
					function (newVal /*, oldVal*/) {
						// is not null anymore when is shown.
						if (newVal !== null) {
							invalidateSize();
						}
					}
				);

				scope.$on('$destroy', function () {
					map = null;
				});

				attrs.$observe('pmtConflictsMap', function (newVal, oldVal) {
					if (newVal == null || newVal === oldVal || newVal === '') {
						return;
					}
					let markerObj = scope.$eval(newVal);
					scope.markerObj = markerObj;
					markerObj.prio = 1;
					initMap(markerObj);
				});

				attrs.$observe('markers', function (newVal, oldVal) {
					if (newVal == null || newVal === oldVal) {
						return;
					}
					extraMarkers = scope.$eval(newVal);
					if (extraMarkers && extraMarkers.length && extraMarkers.length > 0) {
						$timeout(function () {
							initMap(scope.markerObj);
						}, 200); // delay hack to extra markers to not interfere with map init.
					}
				});
			}
		};
	}
]);
